import { StaffTodoListDatastore } from '../datasources/staff_todo_list_datastore';
import { IQuery, IQueryMediator } from 'core-ts-types';
import { IStaffDrivenData } from '../staff_todo_interface';
import { ORM } from 'utility-ts-orm';
import * as _4 from 'lodash4';

export class StaffTodoListQuery implements IQuery {
  private _result: IStaffDrivenData[];

  constructor(private staffTodoListDatastore: StaffTodoListDatastore, private EventCategoryEnum: any) {
    ORM.registerQuery(this, staffTodoListDatastore);
  }

  run(): StaffTodoListQuery {
    this._result = this.staffTodoListDatastore.read();
    this.setUpStaffTodoFields();
    return this;
  }

  get result() {
    return this._result;
  }

  setUpStaffTodoFields(): void {
    _4.forEach(this._result, (staffTodo: IStaffDrivenData) => {
      staffTodo.category = this.EventCategoryEnum.STAFF_DRIVEN_TO_DO;
      staffTodo.show = true;
      staffTodo.status = 'ACTIVE';
      staffTodo.due_date = moment(staffTodo.due_date).format();
    });
  }
}

angular.module('data-ng-staff-todos').service('ngStaffTodoListQuery', StaffTodoListQuery);



// WEBPACK FOOTER //
// ./app/vendor/data-ng-staff-todos/src/queries/staff_todo_list_query.ts